import storeAPI from "./storeAPI";
import taxesAPI from "adminPanel/taxes/taxesAPI";
import {
  getIsEgyptianTaxEnabled,
  getIsSyrianTaxEnabled,
} from "helpers/TaxSystemHelper";

export type PosTaxLinkInvalidReason =
  | "egyptStore"
  | "egyptDevice"
  | "syriaStation";

type ValidityResult = {
  isValid: boolean;
  reason?: PosTaxLinkInvalidReason;
};

const ok = (): ValidityResult => ({ isValid: true });
const fail = (reason: PosTaxLinkInvalidReason): ValidityResult => ({
  isValid: false,
  reason,
});

async function checkApi(
  call: () => Promise<{ data: boolean }>,
  reason: PosTaxLinkInvalidReason,
): Promise<ValidityResult> {
  try {
    const res = await call();
    return res.data === false ? fail(reason) : ok();
  } catch {
    return fail(reason);
  }
}

export default async function checkPosTaxLinkValidity(
  posId: string | null | undefined,
): Promise<ValidityResult> {
  const egyptEnabled = getIsEgyptianTaxEnabled();
  const syriaEnabled = getIsSyrianTaxEnabled();

  if (!posId) {
    if (!egyptEnabled && !syriaEnabled) return ok();
    return fail(syriaEnabled ? "syriaStation" : "egyptStore");
  }

  if (egyptEnabled) {
    const storeCheck = await checkApi(
      () => storeAPI.CheckEgyptPosStoreValidity(posId),
      "egyptStore",
    );
    if (!storeCheck.isValid) return storeCheck;

    const deviceCheck = await checkApi(
      () => taxesAPI.IsPosLinkedWithDevice(posId),
      "egyptDevice",
    );
    if (!deviceCheck.isValid) return deviceCheck;
  }

  if (syriaEnabled) {
    return checkApi(
      () => taxesAPI.IsPosStoreLinkedToStation(posId),
      "syriaStation",
    );
  }

  return ok();
}
